module.exports = __webpack_public_path__ + "img/logo.4ea9b0c4.png";